import api from '@/store/api'

export default {

  loadUser ({ commit }) {
    return api.get('user.json')
      .then(res => res.data.id && commit('SET_USER', res.data))
      .catch(error => console.log(error))
  },

  loadGroups ({ commit }) {
    return api.get('groups.json?isArray=1')
      .then(res => res.data && commit('SET_GROUPS', res.data))
      .catch(error => console.log(error))
  },
  loadWatchlists ({ commit }) {
    return api.get('watchlists.json?isArray=1')
      .then(res => res.data && commit('SET_WATCHLISTS', res.data))
      .catch(error => console.log(error))
  },

  loadEmailAlerts ({ commit }) {
    return api.get('email_alert/email_alerts2.json')
      .then(res => res.data && commit('SET_EMAIL_ALERTS', res.data))
      .catch(error => console.log(error))
  },

  loadTrackedBacktests ({ commit }) {
    return api.get('backtest_tracking.json?isArray=true')
      .then(res => res.data && commit('SET_BACKTESTS', res.data))
      .catch(error => console.log(error))
  },

  loadInsiderAlerts ({ commit }) {
    return api.get('insider_alerts.json')
      .then(res => commit('SET_INSIDER_ALERTS', res.data))
      .catch(error => console.log(error))
  },
  loadTradingModels ({ commit, rootState }) {
    return api.get('trading_models.json')
      .then(res => commit('SET_TRADING_MODELS', { tradingModels: res.data, rootState }))
      .catch(error => console.log(error))
  },
  loadSharedModels ({ commit, rootState }) {
    return api.get('shared_models.json')
      .then(res => commit('SET_SHARED_MODELS', { sharedModels: res.data, rootState }))
      .catch(error => console.log(error))
  },
  loadScreens ({ commit, rootState }) {
    return api.get('screens.json')
      .then(res => commit('SET_SCREENS', {screens: res.data, rootState }))
      .catch(error => console.log(error))
  },
  loadMostActiveStocks ({ commit, rootState }) {
    return api.get('most_active_stocks.json')
      .then(res => commit('SET_MOST_ACTIVE_STOCKS', res.data))
      .catch(error => console.log(error))
  },
  loadMostActiveFilers ({ commit, rootState }) {
    return api.get('most_active_filers.json')
      .then(res => commit('SET_MOST_ACTIVE_FILERS', res.data))
      .catch(error => console.log(error))
  },
  loadTrendingStocks ({ commit, rootState }) {
    return api.get('trending_stocks.json')
      .then(res => commit('SET_TRENDING_STOCKS', res.data))
      .catch(error => console.log(error))
  },
  loadTrendingFilers ({ commit, rootState }) {
    return api.get('trending_filers.json')
      .then(res => commit('SET_TRENDING_FILERS', res.data))
      .catch(error => console.log(error))
  }

}
